<div class="top-bar">
  <div class="d-none-d">
    <div class="flex flex-row ai-start">
      <div class="ml-auto flex flex-column gap-2 color-white ai-center">

        <button data-test-id="common-button-mute"
                type="button"
                (click)="onVolumeChange()"
                class="min-[1000px]:hidden! bg-[#00000080] px-3 py-1.5 rounded-full text-white! absolute top-8 right-3 z-10 cursor-pointer">
          @if (volume()) {
            <sens-icon [size]="24" icon="#icon-mute"/>
          } @else {
            <sens-icon [size]="24" icon="#icon-volume"/>
          }
        </button>
      </div>
    </div>
  </div>

  <div class="d-none-m">
    <div class="top-bar">

      <div #target class="absolute bottom-0 left-1/2 -translate-1/2 w-[700px] max-w-dvw"></div>

      <div class="flex flex-row gap-2 items-center py-3 max-w-[1000px] mx-auto">
        <a routerLink="/" class="block basis-[90px] shrink-0" (click)="onLogoClick()">
          <img [src]="'/assets/img/logo.svg'" class="block" [width]="90" [height]="36" alt="Sens">
        </a>
        <!--    <sens-search-widget class="w-full block min-[1000px]:hidden!"/>-->
        <sens-search-widget [ref$]="target" class="w-full hidden min-[1000px]:block!"/>
      </div>
    </div>
  </div>

</div>

<sens-aside-bar class="aside-bar"/>

<main class="main" [class.not-an-adult]="!isUserAdult()">
  <router-outlet/>
  <sens-footer/>
</main>
<sens-bottom-bar class="bottom-bar"/>
